
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type garageRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function garageRT(): TemplateResult<garageRTRootProps> {
    return _createElement('div', { 'className': 'cm_garage' }, _createElement('a', {
        'className': 'cm_toggle-dropdown garage-button',
        'title': 'Garage: ' + this.size + ' item(s)',
        'tabIndex': '0',
        'role': 'button'
    }, _createElement('div', { 'className': 'garage-icon-container ' + (this.size ? '' : 'garage-full') }, _createElement('div', { 'className': 'garage-icon cm_icon_garage__background' }), this.size ? _createElement('span', {
        'className': 'garage-size countPill countPill--positive',
        'key': '280'
    }, this.size) : null), _createElement('span', { 'className': 'garage-label' }, _translate(`garage_title`))), [this.garageDropdown(function () {
            function repeatItems1(items, itemsIndex) {
                return [items(function () {
                        return _createElement('div', { 'className': 'garage-item' }, _createElement('span', {
                            'className': 'select-model',
                            'onClick': this.selectVehicle
                        }, this.vehicleString), _createElement('span', {
                            'className': 'remove-model',
                            'onClick': this.removeVehicle
                        }, [_createElement('svg', {
                                'className': 'cm_icon cm_icon-times',
                                'height': '20px',
                                'role': 'img',
                                'viewBox': '0 0 22 22',
                                'key': '1930'
                            }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))]));
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_garageDropdown' }, this.template === 'list' ? _createElement('div', {
                'className': 'cmTemplate_list',
                'key': '31'
            }, _createElement('div', { 'className': 'garage-content' }, _createElement('div', {
                'className': 'clear-garage',
                'onClick': this.clearGarage
            }, _translate(`garage_clear`)), _createElement.apply(this, [
                'div',
                { 'className': 'cmRepeater_items' },
                _map(this.items, repeatItems1.bind(this))
            ]), [this.addButton(function () {
                    return _createElement('div', { 'className': 'add-vehicle  button button--primary cm_addButton' }, [window.Convermax.config?.garageButtonText || _translate(`garage_add_button`)]);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })])) : null, this.template === 'empty' ? _createElement('div', {
                'className': 'cmTemplate_empty',
                'key': '1402'
            }, _createElement('div', { 'className': 'garage-content' }, [this.addButton(function () {
                    return _createElement('div', { 'className': 'add-vehicle  button button--primary cm_addButton' }, [window.Convermax.config?.garageButtonText || _translate(`garage_add_button`)]);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })], _createElement('ul', {}, _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_one`)), _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_two`)), _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_three`))))) : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:addButton","cm:addButton","cm:garageDropdown"]